import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _span;
var _excluded = ["checked", "onChange", "disabled", "title", "subtitle", "error", "errorMessage", "className", "size", "indeterminate", "name", "inputElProps"];
import { forwardRef } from 'react';
import { clsx } from 'clsx';
import CheckmarkSquare from '@crehana/compass.icons.fill/CheckmarkSquare';
import MinusSquare from '@crehana/compass.icons.fill/MinusSquare';
import Square from '@crehana/compass.icons.outline/Square';
import { getSquareColors } from "./utils";

// TODO: Adjust all the checkbox states from compass.ui
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Checkbox = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    title = _ref.title,
    subtitle = _ref.subtitle,
    error = _ref.error,
    errorMessage = _ref.errorMessage,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'm' : _ref$size,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    name = _ref.name,
    inputElProps = _ref.inputElProps,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var renderCheckedbox = function renderCheckedbox(indeterminateState) {
    var checkedboxClasses = clsx('tw-z-1', 'tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem]  tw-min-w-[2.4rem]', 'tw-cursor-pointer tw-transition-colors');
    if (indeterminateState) {
      return /*#__PURE__*/_jsx(MinusSquare, {
        className: checkedboxClasses
      });
    }
    return /*#__PURE__*/_jsx(CheckmarkSquare, {
      className: checkedboxClasses
    });
  };

  // The icons gets its colors from the text property inherited from its parent
  var checkboxIconColors = getSquareColors(disabled, checked, errorMessage, error);
  return /*#__PURE__*/ /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */_jsxs("label", _objectSpread(_objectSpread({
    className: clsx('tw-flex tw-justify-center tw-relative', 'tw-gap-1.2', disabled ? 'tw-pointer-events-none' : 'tw-cursor-pointer', title && subtitle ? 'tw-items-start' : 'tw-items-center', checkboxIconColors, className),
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  }, otherProps), {}, {
    children: [/*#__PURE__*/_jsx("input", _objectSpread(_objectSpread({}, inputElProps), {}, {
      className: "tw-opacity-0 tw-absolute tw-inset-0",
      style: {
        zIndex: '-1'
      },
      type: "checkbox",
      disabled: disabled,
      onChange: onChange,
      onClick: function onClick(e) {
        return e.stopPropagation();
      },
      name: name,
      ref: ref
    })), /*#__PURE__*/_jsx("span", {
      className: "tw-inline-flex tw-items-center tw-justify-center tw-relative",
      children: !disabled && checked ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [_span || (_span = /*#__PURE__*/_jsx("span", {
          className: "tw-z-0 tw-h-1.6 tw-w-1.6 tw-bg-primary-light-100 tw-absolute"
        })), renderCheckedbox(indeterminate)]
      }) : /*#__PURE__*/_jsx(Square, {
        className: clsx('tw-z-1', 'tw-h-2.4 tw-w-2.4 tw-min-h-[2.4rem] tw-min-w-[2.4rem]', 'tw-transition-colors')
      })
    }), title && (title || subtitle || errorMessage) && /*#__PURE__*/_jsxs("span", {
      className: "tw-inline-grid",
      children: [title && /*#__PURE__*/_jsx("span", {
        className: clsx(size === 'm' ? 'tw-font-subtitle5' : 'tw-font-body5', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-800 dark:tw-text-neutral-light-100'),
        children: title
      }), subtitle && size === 'm' && /*#__PURE__*/_jsx("span", {
        className: clsx('tw-font-body5', disabled ? 'tw-text-neutral-light-500' : 'tw-text-neutral-light-700 dark:tw-text-neutral-dark-500'),
        children: subtitle
      }), errorMessage && /*#__PURE__*/_jsx("span", {
        className: clsx('tw-font-caption', disabled ? 'tw-text-neutral-light-500' : 'tw-text-alert-500'),
        children: errorMessage
      })]
    })]
  }))
  /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */;
});
export default Checkbox;